import React, { Component } from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';


const Invoice = (props) => {
    let date = props.invoice? moment(props.invoice.invoice_date).format('L') : '';
    return(
      <tr>
        <td>{props.invoice? props.invoice.invoice_number : ''}</td>
        <td className="hidden-xs-down">{props.invoice.has_boxes?
            <span className="badge badge-pill badge-success">Processed</span>
              :
            <span className="badge badge-pill badge-warning">In progress</span>}
        </td>
        <td>{(props.invoice && props.invoice.vendor)? props.invoice.vendor.name : ''}</td>
        <td className="hidden-xs-down">{date}</td>
        <td className="hidden-xs-down">{props.invoice? props.invoice.user : ''}</td>
        <td>
          <span className="d-flex">
          {props.invoice.has_boxes ?
            <span className="d-flex">
              <NavLink className="ml-05 btn-sm btn-primary" to={`/invoice/${props.invoice.id}`}>
                <i className="fa fa-eye"></i>
              </NavLink>
              <NavLink className="ml-05 btn-sm btn-success" to={`/credit_note/new?i=${props.invoice.id}`}>
                <i className="fa fa-arrow-right"></i>
              </NavLink>
            </span>
          :
            <NavLink
              className="ml-05 btn-sm btn-primary"
              to={props.invoice.purchaseorder ? `/purchase_orders/${props.invoice.purchaseorder}/invoice` : `/invoice/${props.invoice.id}`}
            >
              <i className="fa fa-edit "></i>
            </NavLink>
          }
          </span>
        </td>
      </tr>
    )
}

export default class InvoiceList extends Component {
  render() {
    return (
      <tbody>
        {this.props.invoices.invoices.map((invoice,index) => {
          return(
            <Invoice invoice={invoice} editInvoice={this.props.editInvoice} key={index}/>
          )
        })}
      </tbody>
    );
  }
}
